interface EmergencyWarningProps {
  openModal: () => void;
}

export const EmergencyWarning = ({ openModal }: EmergencyWarningProps) => {
  return (
    <div className="w-full flex flex-col items-center justify-center px-6 mb-4">
      <p className="w-full text-center text-xs bg-blue-50 px-4 py-4 mmh48:py-3 rounded-xl">
        Ce service n&apos;est pas adapté aux urgences.
        <br />
        En cas de{' '}
        <span className="underline cursor-pointer" onClick={openModal}>
          symptômes graves
        </span>
        , appelez le 15.
      </p>
    </div>
  );
};
